import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const MaintenanceModal = ({ show, handleClose, fetchData, editData }) => {
  const [formData, setFormData] = useState({
    from_date: "",
    from_time: "",
    to_date: "",
    to_time: "",
  });

  useEffect(() => {
    if (editData) {
      const [startDate, startTime] = editData.date_start.split("T");
      const [endDate, endTime] = editData.date_finish.split("T");

      setFormData({
        from_date: startDate,
        from_time: startTime?.substring(0, 5) || "",
        to_date: endDate,
        to_time: endTime?.substring(0, 5) || "",
      });
    } else {
      setFormData({
        from_date: "",
        from_time: "",
        to_date: "",
        to_time: "",
      });
    }
  }, [editData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const fromDateTime = new Date(
        `${formData.from_date}T${formData.from_time}:00`
      );
      const toDateTime = new Date(`${formData.to_date}T${formData.to_time}:00`);

      const fromUTC = new Date(
        fromDateTime.getTime() - fromDateTime.getTimezoneOffset() * 60000
      );
      const toUTC = new Date(
        toDateTime.getTime() - toDateTime.getTimezoneOffset() * 60000
      );

      const payload = {
        from_date: fromUTC.toISOString().split("T")[0],
        from_time: fromUTC.toTimeString().split(" ")[0],
        to_date: toUTC.toISOString().split("T")[0],
        to_time: toUTC.toTimeString().split(" ")[0],
      };

      const token = sessionStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (editData) {
        payload.id = editData.id;

        await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/maintenance/update`,
          payload,
          config
        );
        Swal.fire({
          icon: "success",
          title: "¡Actualizado!",
          text: "El registro se actualizó correctamente",
          timer: 2000,
        });
      } else {
        await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/maintenance/create`,
          payload,
          config
        );
        Swal.fire({
          icon: "success",
          title: "¡Creado!",
          text: "Nuevo registro creado correctamente",
          timer: 2000,
        });
      }

      handleClose();
      fetchData();
    } catch (error) {
      console.error("Error al guardar el mantenimiento:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al guardar los cambios",
      });
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {editData ? "Editar registro" : "Agregar registro"}
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      >
        <Modal.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="fromDate">
                <Form.Label>Fecha Inicio</Form.Label>
                <Form.Control
                  type="date"
                  name="from_date"
                  value={formData.from_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="fromTime">
                <Form.Label>Hora Inicio</Form.Label>
                <Form.Control
                  type="time"
                  name="from_time"
                  value={formData.from_time}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="toDate">
                <Form.Label>Fecha Fin</Form.Label>
                <Form.Control
                  type="date"
                  name="to_date"
                  value={formData.to_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="toTime">
                <Form.Label>Hora Fin</Form.Label>
                <Form.Control
                  type="time"
                  name="to_time"
                  value={formData.to_time}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="primary" type="submit">
            {editData ? "Actualizar" : "Agregar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MaintenanceModal;
